module.exports = __webpack_public_path__ + "static/media/info-icon.96896f10.svg";